// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyFloorPlanCreateResponseV2WebDto, UserPropertyFloorPlanCreateV2RequestDto } from '../..';

export const RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Path =
  '/api/web/v2/users/properties/floorPlans/create';

/**
 * Create a floor plan for the property
 */
export const RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create = (
  postData: UserPropertyFloorPlanCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanCreateV2RequestDto,
    UserPropertyFloorPlanCreateResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanCreateV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
